import axios from "axios";
import { jwtDecode } from "jwt-decode";
import {
  RefreshCredentials,
  SignInCredentials,
  SignInResponse,
} from "../types/session";

export const signInService = async ({
  email,
  password,
}: SignInCredentials): Promise<SignInResponse> => {
  const response = await axios.post(
    "https://api-backoffice.datasales.info/p2-dev/sessions/sign-in/fidelize",
    {
      email,
      password,
      webapp: true,
    }
  );

  const {
    token,
    name,
    permissions,
    company: {
      id: companyId,
      name: companyName,
      cnpj: companyDocument,
      ID_SEGMENT: segmentId,
      deliveryVip,
    },
  } = response.data;

  if (permissions.crm.filter((e) => e.serviceId === 78).length === 0) {
    return;
  }

  const parsedToken: any = jwtDecode(token);

  return {
    token,
    permissions,
    user: {
      segmentId,
      companyId,
      companyName,
      companyDocument,
      name,
      deliveryVip,
      email,
      id: parsedToken.user_id as number,
    },
  };
};

export const refreshSession = async ({
  token,
  userId,
}: RefreshCredentials): Promise<SignInResponse> => {
  const response = await axios.get(
    `https://kldlktujc6.execute-api.us-east-1.amazonaws.com/prd/users/${userId}`,
    {
      headers: { Authorization: token },
    }
  );

  const {
    company: {
      id: companyId,
      name: companyName,
      cnpj: companyDocument,
      ID_SEGMENT: segmentId,
    },
    user: { email, name, permissions },
  } = response.data;

  return {
    token,
    permissions,
    user: {
      segmentId,
      companyId,
      companyName,
      companyDocument,
      name,
      email,
      id: userId,
    },
  };
};

export const forgotPassword = async ({
  email,
  redirect,
}: {
  email: string;
  redirect: string;
}) => {
  const response = await axios.post(
    "https://api-backoffice.datasales.io/p2-prd/session/forgot",
    { email, redirect }
  );

  return response.data;
};

export const resetPassword = async ({
  token,
  password,
}: {
  token: string;
  password: string;
}) => {
  const response = await axios.post(
    "https://api-backoffice.datasales.io/p2-prd/session/reset",
    { token, password }
  );

  return response.data;
};
